import { ShoppingBagIcon } from '@heroicons/react/24/outline'
import { useTranslation } from 'libs/i18n'
import { NavLink } from 'libs/router'
import { format } from 'libs/dates'
import { Currency, Panel, PanelEmpty } from 'shared/components'
import { Spinner } from 'shared/atoms'
import { routes } from 'config/routes'
import { useFetchSales } from './queries/useFetchSales'
import { MAX_PANEL_ITEMS, viewAllClassName } from '../panel'

type UserSalesProps = {
	userId: string
}

export const UserSales = ({ userId }: UserSalesProps) => {
	const { t } = useTranslation()
	const { sales, isSalesLoading } = useFetchSales(userId)
	const results = sales?.data?.results ?? []

	const renderContent = () => {
		if (isSalesLoading && !results.length) return <Spinner />
		if (!results.length) return <PanelEmpty>{t('No sales yet')}</PanelEmpty>

		return (
			<ul className="divide-y divide-border">
				{results.slice(0, MAX_PANEL_ITEMS).map((sale) => (
					<li key={sale.id} className="flex items-center justify-between gap-3 py-2 text-[12px]">
						<div className="min-w-0">
							<NavLink
								className="block truncate font-medium text-foreground hover:text-primary"
								to={routes.saleEdit(String(sale.id))}>
								{sale.product_name}
							</NavLink>
							<span className="block truncate text-[11px] tabular-nums text-muted-foreground">
								{format(new Date(sale.created), 'dd.MM.yyyy')} · {sale.receipt_reference}
							</span>
						</div>
						<Currency className="shrink-0 font-medium tabular-nums" price={sale.subtotal} />
					</li>
				))}
			</ul>
		)
	}

	return (
		<Panel
			title={t('Sales')}
			icon={<ShoppingBagIcon />}
			action={
				results.length > 0 && (
					<NavLink className={viewAllClassName} to={`${routes.saleIndex}?account_id=${userId}`}>
						{t('View all')}
					</NavLink>
				)
			}>
			{renderContent()}
		</Panel>
	)
}
